import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/saved-items";

export const savedItemsApi = {
  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  save: (itemType: string, itemId: string) =>
    apiPost<{ savedItem: Record<string, unknown> }>(BASE, { itemType, itemId }),

  unsave: (itemType: string, itemId: string) =>
    apiDelete<{ message: string }>(`${BASE}/${itemType}/${itemId}`),

  getByType: (itemType: string, params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/${itemType}?${searchParams.toString()}`);
  },
};
